export const POST_ITEMS_PER_PAGE = 3;
export const REPLY_ITEMS_PER_PAGE = 3;
